import React, { ReactNode } from "react";
import { Switch, SwitchProps } from "@mui/material";

export type WcSwitchProps = SwitchProps & {
  controlDisabled?: boolean;
  children?: ReactNode;
  color?: string;
};

export const WcSwitch = ({
  controlDisabled = false,
  color,
  checked,
  ...props
}: WcSwitchProps) => (
  <Switch
    color={color}
    disabled={controlDisabled}
    checked={checked}
    {...props}
  />
);

export default WcSwitch;
